<template>
    <div>
        <div class="page flex-col">
            <div class="Menubox_1 flex-col">
                <div class="flex-row">
                    <div class="box_t_1">
                        <img class="image_1"
                        referrerpolicy="no-referrer"
                        :src="logo" />
                    </div>
                    <div class="box_t_2 flex-row">
                        <Menu ref="menu"></Menu>
                    </div>
                    <div class="box_t_3 flex-row">
                        <img class="thumbnail_1" referrerpolicy="no-referrer" :src="cn" style="cursor: pointer" @click="setZhOrEn('zh')"/>
                        <span class="text_9" style="color: #000; cursor: pointer;" @click="setZhOrEn('zh')">中文</span>
                        <img class="thumbnail_2" referrerpolicy="no-referrer" :src="en" style="cursor: pointer" @click="setZhOrEn('en')"/>
                        <span class="text_10" style="color: #000; cursor:pointer;" @click="setZhOrEn('en')">EN</span>
                        <img class="thumbnail_3" referrerpolicy="no-referrer" :src="els" style="cursor: pointer" @click="setZhOrEn('ru')"/>
                        <span class="text_11" style="color: #000; cursor:pointer;" @click="setZhOrEn('ru')">РУС</span>
                    </div>
                </div>
            </div>
            <div class="mobile-header" :class="{ 'is-open': mobileMenuOpen }">
                <div class="mobile-header__top">
                    <button class="mobile-header__toggle" @click="toggleMobileMenu" type="button">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <img class="mobile-header__logo" :src="logo" alt="先河环保" @click="toLink('/Client/Index')"/>
                    <button class="mobile-header__search" type="button" @click="toggleSearchPanel"></button>
                </div>
                <transition name="search-panel-slide">
                    <div class="mobile-header__search-panel" v-if="searchPanelOpen">
                        <div class="mobile-header__search-input-wrapper">
                            <input 
                                type="text" 
                                class="mobile-header__search-input" 
                                v-model="searchKeyword"
                                placeholder="请输入搜索关键词"
                                @keyup.enter="handleSearch"
                            />
                            <button class="mobile-header__search-btn" type="button" @click="handleSearch">
                                <span class="el-icon-search"></span>
                            </button>
                            <button class="mobile-header__search-close" type="button" @click="closeSearchPanel">
                                <span class="el-icon-close"></span>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="mobile-menu-fade">
                    <div class="mobile-header__drawer" v-if="mobileMenuOpen">
                        <div class="mobile-header__drawer-top">
                            <img class="mobile-header__drawer-logo" :src="logo" alt="先河环保" />
                            <button class="mobile-header__close" type="button" @click="toggleMobileMenu">×</button>
                        </div>
                        <nav class="mobile-header__nav">
                            <div
                              v-for="item in MenuList"
                              :key="item.ID"
                              class="mobile-header__nav-group"
                            >
                              <button
                                :class="['mobile-header__nav-item', { 'mobile-header__nav-item--expandable': item.children && item.children.length > 0 }]"
                                type="button"
                                @click="handleMobileLink(item)"
                              >
                                <span class="mobile-header__nav-text">{{ item.Name }}</span>
                                <span 
                                  v-if="item.children && item.children.length > 0" 
                                  class="mobile-header__nav-toggle"
                                >
                                  {{ item.expanded ? '−' : '+' }}
                                </span>
                              </button>
                              
                              <!-- 二级菜单 -->
                              <transition name="submenu-slide">
                                <div 
                                  v-if="item.expanded && item.children && item.children.length > 0" 
                                  class="mobile-header__nav-submenu"
                                >
                                  <div 
                                    v-for="subItem in item.children" 
                                    :key="subItem.id"
                                    class="mobile-header__nav-submenu-group"
                                  >
                                    <button
                                      :class="['mobile-header__nav-submenu-item', { 'mobile-header__nav-submenu-item--expandable': subItem.children && subItem.children.length > 0 }]"
                                      type="button"
                                      @click="subItem.children && subItem.children.length > 0 ? toggleSubMenuItem(subItem) : handleSubMenuClick(subItem.url)"
                                    >
                                      <span class="mobile-header__nav-submenu-text">{{ subItem.label }}</span>
                                      <span 
                                        v-if="subItem.children && subItem.children.length > 0" 
                                        class="mobile-header__nav-toggle"
                                      >
                                        {{ subItem.expanded ? '−' : '+' }}
                                      </span>
                                    </button>
                                    
                                    <!-- 三级菜单 -->
                                    <transition name="submenu-slide">
                                      <div 
                                        v-if="subItem.expanded && subItem.children && subItem.children.length > 0" 
                                        class="mobile-header__nav-submenu mobile-header__nav-submenu--level2"
                                      >
                                        <button
                                          v-for="thirdItem in subItem.children"
                                          :key="thirdItem.id"
                                          class="mobile-header__nav-submenu-item mobile-header__nav-submenu-item--level2"
                                          type="button"
                                          @click="handleSubMenuClick(thirdItem.url)"
                                        >
                                          {{ thirdItem.label }}
                                        </button>
                                      </div>
                                    </transition>
                                  </div>
                                </div>
                              </transition>
                            </div>
                        </nav>
                        <div class="mobile-header__actions">
                            <button type="button" @click="setZhOrEn('zh')">中文</button>
                            <button type="button" @click="setZhOrEn('en')">EN</button>
                            <button type="button" @click="setZhOrEn('ru')">РУС</button>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="view-content scroll-container" v-loading="loading">

                <transition name="fade-transform" mode="out-in">
                    <router-view></router-view>
                </transition>
                <div class="text-wrapper_16 ">
                    <div class="text_41">版权所有&nbsp;&nbsp;河北先河环保科技股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Copyright&nbsp;©&nbsp;&nbsp;&nbsp;2017&nbsp;SailHero&nbsp;Inc&nbsp;.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="text-decoration: none;color: inherit;">冀ICP备14021856号-5</a></div>
                  </div>
                <footer class="mobile-footer-copyright">
                  <div class="mobile-footer-copyright__content">
                    <p class="mobile-footer-copyright__text">
                      版权所有 河北先河环保科技股份有限公司
                    </p>
                    <p class="mobile-footer-copyright__text">
                      Copyright © 2017 SailHero Inc.
                    </p>
                    <p class="mobile-footer-copyright__icp">
                      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">冀ICP备14021856号-5</a>
                    </p>
                  </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import Menu  from "./components/Menu";
    export default{
    components:{
        Menu
    },
    data(){
        return{
            logo: require('@/assets/client/logo.png'),
            cn: require('@/assets/client/cn.png'),
            en: require('@/assets/client/en.png'),
            els: require('@/assets/client/els.png'),
            loading: false,
            url: process.env.VUE_APP_WEBBASEURL,
            mobileMenuOpen: false,
            searchPanelOpen: false,
            searchKeyword: '',
            MenuList: [ 
                { ID: '1', Url:"/Client/Index",Target:"",Name:"网站首页", expanded: false, children: [] },
                { ID:'2',Url:"/Client/AboutSailHero/index",Target:"",Name:"关于先河", expanded: false, children: [
                    { label: '先河介绍', id: 'introduction', url: '/Client/AboutSailHero/Introduction' },
                    { label: '党建工作', id: 'partyWork', url: '/Client/AboutSailHero/PartyBuildingWork' },
                    { label: '社会责任', id: 'socialResponsibility', url: '/Client/AboutSailHero/SocialResponsibility' },
                    { label: '领导关怀', id: 'leadershipCare', url: '/Client/AboutSailHero/LeadershipCare' },
                    { label: '企业文化', id: 'corporateCulture', url: '/Client/AboutSailHero/CorporateCulture' },
                    { label: '人力资源', id: 'humanResources', url: '/Client/AboutSailHero/HumanResources' }
                ] },
                { ID: '3', Url: "/Client/Business/Product", Target: "", Name: "产品中心", expanded: false, children: [] },
                { ID: '4', Url:"/Client/Business/Solution",Target:"",Name:"解决方案", expanded: false, children: [] },
                {ID:'5',Url:"/Client/NewsTrends",Target:"",Name:"新闻动态", expanded: false, children: [
                    { label: '公司动态', id: 'NT01', url: '/Client/NewsTrends?type=NT01' },
                    { label: '媒体关注', id: 'NT02', url: '/Client/NewsTrends?type=NT02' },
                    { label: '行业新闻', id: 'NT03', url: '/Client/NewsTrends?type=NT03' },
                    { label: '影像先河', id: 'NT04', url: '/Client/NewsTrends?type=NT04' }
                ] },
                {ID:'7',Url:"/Client/InvestorRelations",Target:"",Name:"投资者关系", expanded: false, children: [
                    { label: '公告信息', id: 'IT01', url: '/Client/InvestorRelations?type=IT01' },
                    { label: '投资者教育', id: 'IT02', url: '/Client/InvestorRelations?type=IT02' },
                    { label: '投资者服务', id: 'IT03', url: 'https://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300137&orgId=9900014612' },
                    { label: '股票信息', id: 'IT04', url: '/Client/InvestorRelations?type=IT04' }
                ] },
                { ID: '9', Url:"/Client/Member",Target:"",Name:"分子公司", expanded: false, children: [] },
                {ID:'10',Url:"/Client/ContactUs/index",Target:"",Name:"联系我们", expanded: false, children: [] }
            ],
            Product: [],
            Solution: []
        }
    },
    methods: {
        toLink(path, target) {
            this.$router.push(path);
        },
        setLoading(isLoading) {
            this.loading = isLoading;
        },
        setZhOrEn(type) {
            if (type == "zh") {
                window.location.href = 'https://www.sailhero.com';
            } else if (type == "en") {
                window.location.href = 'https://www.sailhero.com/enweb';
            } else if (type == "ru") {
                window.location.href = 'https://www.sailhero.com/ruweb';
            }
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        handleMobileLink(item) {
            // 如果有子菜单，则展开/收起，不跳转
            if (item.children && item.children.length > 0) {
                this.toggleMenuItem(item);
            } else {
                // 没有子菜单，执行跳转并关闭菜单
                this.mobileMenuOpen = false;
                if (item.Url && item.Url !== "#") {
                    this.toLink(item.Url, item.Target);
                }
            }
        },
        getDataTree(businessType) {
            let that = this;
            that.$api.post("/Client/getBusinessDataTree", { businessType: businessType },
                function (res) {
                    if (res.code === "200") {
                        if (businessType == "产品中心") {
                            that.Product = res.data;
                            that.buildMenuWithChildren('3', that.Product);
                        }
                        else {
                            that.Solution = res.data;
                            that.buildMenuWithChildren('4', that.Solution);
                        }
                    }
                },
                function (res) {
                    // 错误处理
                }
            );
        },
        buildMenuWithChildren(menuId, dataTree) {
            // 找到对应的菜单项
            const menuItem = this.MenuList.find(item => item.ID === menuId);
            if (menuItem && dataTree) {
                // 将树形数据转换为子菜单结构
                menuItem.children = dataTree.map(parent => {
                    return {
                        label: parent.label,
                        id: parent.id,
                        expanded: false,
                        children: parent.children ? parent.children.map(child => {
                            return {
                                label: child.label,
                                id: child.id,
                                url: menuId === '3' 
                                    ? `/Client/Business/Product?tpid=${child.id}&tid=&id=`
                                    : `/Client/Business/Solution?tpid=${child.id}&tid=&id=`
                            };
                        }) : []
                    };
                });
            }
        },
        toggleMenuItem(item) {
            // 切换一级菜单的展开状态
            item.expanded = !item.expanded;
        },
        toggleSubMenuItem(subItem) {
            // 切换二级菜单的展开状态
            subItem.expanded = !subItem.expanded;
        },
        handleSubMenuClick(url) {
            // 点击子菜单项，跳转并关闭菜单
            this.mobileMenuOpen = false;
            if (url) {
                // 判断是否为外部链接
                if (url.startsWith('http://') || url.startsWith('https://')) {
                    // 外部链接在新标签页打开
                    window.open(url, '_blank');
                } else {
                    // 内部路由跳转
                    this.toLink(url);
                }
            }
        },
        toggleSearchPanel() {
            // 切换搜索面板的显示/隐藏
            this.searchPanelOpen = !this.searchPanelOpen;
            // 如果打开搜索面板，关闭移动端菜单
            if (this.searchPanelOpen) {
                this.mobileMenuOpen = false;
            }
        },
        closeSearchPanel() {
            // 关闭搜索面板
            this.searchPanelOpen = false;
            this.searchKeyword = '';
        },
        handleSearch() {
            // 执行搜索
            if (this.searchKeyword.trim() === '') {
                return;
            }
            // 关闭搜索面板
            this.searchPanelOpen = false;
            // 跳转到搜索结果页面
            this.$router.push({
                path: '/Client/Search',
                query: {
                    keyword: this.searchKeyword.trim()
                }
            });
            // 清空搜索关键词
            this.searchKeyword = '';
        }
    },
    mounted(){
        // 获取产品中心和解决方案的子菜单数据
        this.getDataTree("产品中心");
        this.getDataTree("解决方案");
    },
    watch:{
    }

}
</script>
<style scoped>
@import '../../assets/client/main.css';
@import '../../assets/client/common.css';
@import '../../assets/client/index-mobile.css';
@import '../../assets/client/main-mobile.css';
/* 隐藏滚动条的同时仍能滚动 */
.scroll-container {
    overflow: auto; /* 启用滚动功能 */
    -ms-overflow-style: none; /* 适用于 Internet Explorer 和旧版 Edge */
    scrollbar-width: none; /* 适用于 Firefox */
}

/* Webkit 浏览器 */
.scroll-container::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
}
.text-wrapper_16 {
    background-color: rgba(13, 115, 255, 1);
     height: 2.61vw;
     position: relative;
     left: 0;
     display: flex;
     justify-content: center;
     align-items: center;
  }
  .text_41 {
    width: 43.7vw;
    height: 0.73vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    line-height: 0.73vw;
    text-align: center;
  }

/* PC端版权栏固定在底部 */
@media (min-width: 769px) {
  .page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
  }

  .view-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .text-wrapper_16 {
    margin-top: auto;
    flex-shrink: 0;
  }
}
</style>
